export default __webpack_public_path__ + "static/media/certificado.b0272218.svg";